const initRhdetailData = {
  
}


export function rhdetailData(
  state = initRhdetailData,
  action
) {
  switch (action.type) {
    case "RH_DETAIL_FETCH_DATA_SUCCESS":
      return action.dataRhdetail;
    default:
      return state;
  }
}
